import React from 'react';
import LogPage from './LogPage';

// Thin wrappers — one per backend log_type. Each renders the generic
// LogPage with the appropriate log_type key.
const make = (logType) => {
  const Wrapped = () => <LogPage logType={logType} />;
  Wrapped.displayName = `Log_${logType}`;
  return Wrapped;
};

// ── Production logs ─────────────────────────────────────────────────────
export const MaterialIssuanceLog        = make('material_issuance');
export const MaterialMovementLog        = make('material_movement');
export const MaterialRejectedLog        = make('material_rejected');
export const EquipmentLogPouching       = make('equipment_log_pouching');
export const EquipmentLogPrinting       = make('equipment_log_printing');
export const EquipmentLogSlitting       = make('equipment_log_slitting');
export const EquipmentLogDoctoring      = make('equipment_log_doctoring');
export const EquipmentLogLamination     = make('equipment_log_lamination');
export const PlatesLog                  = make('plates_log');
export const InksLog                    = make('inks_log');
export const FGTransferNote             = make('fg_transfer_note');

// ── QC / QA logs ────────────────────────────────────────────────────────
export const TemperatureRHLog           = make('temperature_rh');
export const SampleLog                  = make('sample_log');
export const InstrumentUsageLog         = make('instrument_usage');
export const BalanceDailyVerification   = make('balance_daily_verification');
export const BalanceMonthlyCalibration  = make('balance_monthly_calibration');
export const VisualInspectorQualification = make('visual_inspector_qualification');
export const VisualInspectionReport     = make('visual_inspection_report');
export const VisualInspectionEvaluation = make('visual_inspection_evaluation');

// ── Document control ───────────────────────────────────────────────────
export const SOPRequest                 = make('sop_request');
export const SOPDistribution            = make('sop_distribution');
export const ArtworkApproval            = make('artwork_approval');
export const ArtworkDestruction         = make('artwork_destruction');
